/** @format */

import gameAssets from "@themed-assets";
import styles from "../Stats.module.css";
import { useNavigate } from "react-router";

export default function EmptyStats({ redirectTo }) {
  const navigate = useNavigate();

  const handlePlayButton = () => {
    navigate(redirectTo);
  };

  return (
    <div className="flex flex-col items-center justify-items-center h-full">
      <img src={gameAssets.TableEmptyState} />
      <p className="font-medium text-xs text-center mt-4 mb-6">
        Jump into a table to start building your poker profile. After just a few
        hands, we’ll unlock personalised insights—VPIP, PFR, win-rate trends and
        more.
      </p>
      <button className={styles.playButton} onClick={handlePlayButton}>
        Play Poker
      </button>
    </div>
  );
}
